(function () {
    function cmp(id) {
        return window.sharkDmxCmp ? window.sharkDmxCmp(id) : null;
    }

    window.sharkSsrHydrate = function (opts) {
        var payload = null;
        try { payload = JSON.parse(document.getElementById(opts.payloadId).textContent); } catch (e) {}
        var waitFor = opts.waitFor || [];
        var tries = 0;
        function fallbackLoad(c) {
            if (opts.selfLoading || !c) return;
            if (typeof c.load === 'function') c.load();
            else if (c.methods && typeof c.methods.load === 'function') c.methods.load.call(c, {});
        }
        (function hydrate() {
            var sc = cmp(opts.connectId);
            var ready = !!sc;
            for (var i = 0; ready && i < waitFor.length; i++) {
                if (!cmp(waitFor[i])) ready = false;
            }
            if (!ready) {
                if (++tries > 600) {
                    if (window.console && console.warn) console.warn('sharkSsrHydrate: components not ready after ~10s, falling back to load() for ' + opts.connectId);
                    fallbackLoad(sc);
                    return;
                }
                return setTimeout(hydrate, 16);
            }
            if (!payload || (opts.requireKey && !payload[opts.requireKey])) {
                fallbackLoad(sc);
                return;
            }
            var fired = false;
            function inject() {
                if (fired) return;
                fired = true;
                (opts.also || []).forEach(function (a) {
                    var c = cmp(a.connectId);
                    if (!c || payload[a.key] === undefined) return;
                    var d = {};
                    d[a.key] = payload[a.key];
                    c.set({ status: 200, headers: {}, paging: {}, links: {}, data: d });
                    c.dispatchEvent('success');
                    c.dispatchEvent('done');
                });
                sc.set({ status: 200, headers: {}, paging: {}, links: {}, data: payload });
                sc.dispatchEvent('success');
                sc.dispatchEvent('done');
                if (sc.$node) sc.$node.dispatchEvent(new CustomEvent('xhrsuccess', { bubbles: true, detail: { source: sc.name, status: 304, response: { data: payload } } }));
            }
            if (performance.getEntriesByType('paint').length) {
                setTimeout(inject, 0);
            } else {
                try {
                    new PerformanceObserver(function (l, o) { o.disconnect(); setTimeout(inject, 0); }).observe({ type: 'paint', buffered: true });
                } catch (e) {}
                setTimeout(inject, 1200);
            }
        })();
    };
})();
